/** Normalize API status (string or legacy numeric enum) for comparisons. */
export function normalizeSignalStatus(signal: { status?: unknown }): string {
  const s = signal.status;
  if (s === 3 || s === '3') return 'dismissed';
  if (typeof s === 'number' && Number.isFinite(s)) {
    const byIndex = ['new', 'in_progress', 'resolved', 'dismissed'];
    if (s >= 0 && s < byIndex.length) return byIndex[s];
  }
  if (typeof s === 'string') {
    return s.toLowerCase().replace(/-/g, '_');
  }
  return '';
}
